import React, { Component } from 'react';
import './App.css';
import meadow from './content/meadow.svg';
import sun from './content/sun.svg';
import cloud from './content/cloud.svg';
import flowers from './content/flowers.png';
import sheep1 from './content/sheep.svg';
import sheep2 from './content/sheep2.svg';
import sheep3 from './content/sheep3.svg';
import tree from './content/season-158447.svg';


class App extends Component {

    constructor() {
        super();
        this.state = this.initialState();
    }

    componentWillMount() {
        //setup questions
        this.setState({ ...this.state, gameStarted: false, questions: this.setupQuestions() })
    }

    initialState() {
        return { showQuestion: false, showAnswer: false, points: 0, questions: {}, timeRemaining: 60 };
    }

    setupQuestions() {
        const questions = {};
        const x = () => Math.floor(Math.random() * 80 + 2);
        const y = () => Math.floor(Math.random() * 20 + 5);
        const add = () => Math.floor(Math.random()*9+1);
        questions[`sun-1`] = {image: sun, width: '10%', add1: add(), add2: add(), x: 3, y: 77, answered: false }
        questions[`cloud-1`] = {image: cloud, width: '15%', add1: add(), add2: add(), x: x(), y: 77, answered: false }
        questions[`cloud-2`] = {image: cloud, width: '17%', add1: add(), add2: add(), x: x(), y: 75, answered: false }
        questions[`cloud-3`] = {image: cloud, width: '18%', add1: add(), add2: add(), x: x(), y: 74, answered: false }
        questions[`tree-4`] = { image: tree, width: '14%', add1: add(), add2: add(), x: x(), y: 34, answered: false }
        questions[`sheep1-2`] = { image: sheep1, add1: add(), add2: add(), width: '5%', x: x(), y: 33, answered: false }
        questions[`sheep2-3`] = { image: sheep3, width: '7%', add1: add(), add2: add(), x: x(), y: 30, answered: false }
        questions[`tree-3`] = { image: tree, width: '16%', add1: add(), add2: add(), x: x(), y: 29, answered: false }
        questions[`tree-2`] = { image: tree, width: '17%', add1: add(), add2: add(), x: x(), y: 28, answered: false }
        questions[`flowers-3`] = { image: flowers, add1: add(), add2: add(), width: '5%', x: x(), y: 27, answered: false }
        questions[`flowers-4`] = { image: flowers, add1: add(), add2: add(), width: '5%', x: x(), y: 27, answered: false }
        questions[`flowers-5`] = { image: flowers, add1: add(), add2: add(), width: '5%', x: x(), y: 27, answered: false }
        questions[`sheep2-1`] = { image: sheep3, width: '8%', add1: add(), add2: add(), x: x(), y: 26, answered: false }
        questions[`sheep2-2`] = { image: sheep3, width: '8%', add1: add(), add2: add(), x: x(), y: 26, answered: false }
        questions[`tree-1`] = { image: tree, width: '18%', add1: add(), add2: add(), x: x(), y: 25, answered: false }
        questions[`sheep2-4`] = { image: sheep3, width: '10%', add1: add(), add2: add(), x: x(), y: 20, answered: false }
        questions[`sheep2-4`] = { image: sheep3, width: '12%', add1: add(), add2: add(), x: x(), y: 15, answered: false }
        questions[`flowers-2`] = { image: flowers, add1: add(), add2: add(), x: x(), y: 2, answered: false }
        questions[`sheep1-1`] = { image: sheep1, add1: add(), add2: add(), x: x(), y: 2, answered: false }
        return questions;
    }

    startTimer() {
        const questions = Object.keys(this.state.questions)
                            .map((key) => ({ id: key, ...this.state.questions[key] }))
                            .filter(q => q.answered === false);
        setTimeout(() => {
            if (this.state.timeRemaining > 0 && questions.length > 0) {
                this.setState({ ...this.state, timeRemaining: this.state.timeRemaining - 1 })
                this.startTimer();
            }
        }, 1000);
    }

    reset() {
        this.state = this.initialState();
        this.state.questions = this.setupQuestions();
        this.setState(this.state);
        this.startTimer();
    }

    revealQuestion(question) {
        const questions = this.state.questions;
        questions[question].answered = true;
        this.setState({ ...this.state, showQuestion: true, currentQuestion: questions[question], questions });
    }

    answerQuestion(answer) {
        const { add1, add2 } = this.state.currentQuestion
        let points = this.state.points
        if (answer === add1 + add2) {
            points = points + 1;
        } else {
            points = points - 1;
        }
        this.setState({ ...this.state, userAnswer: answer, showQuestion: false, points });
    }

  render() {
      const N = 20;
      const answers = Array.apply(null, {length: N}).map(Number.call, Number);
      const { timeRemaining } = this.state;
      const minutes = Math.floor(timeRemaining / 60);
      const seconds = timeRemaining % 60;
      function str_pad_left(string,pad,length) {
          return (new Array(length+1).join(pad)+string).slice(-length);
      }
      const finalTime = str_pad_left(minutes,'0',2)+':'+str_pad_left(seconds,'0',2);

      if (timeRemaining === 0) {
          return <div className="App">
            <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: '#7CCCE8' }}>
                <img src={meadow} alt="meadow" style={{ width: '100%', position: 'absolute', bottom: 0, left: 0 }} />
                <div className="question-container" style={{ fontFamily: 'Bangers'}}>
                    <p>Times up!<br /> You got <span style={{ color: 'white', fontWeight: 'bold' }}>{ this.state.points } points</span>.</p>
                    <div style={{ backgroundColor: 'white', padding: 10, color: 'black', borderRadius: 5, border: '1px solid lighgrey' }} onClick={() => this.reset()}>Start Again</div>
                </div>
            </div>
          </div>
      }

      if (this.state.gameStarted === false) {
          return <div className="App">
            <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: '#7CCCE8' }}>
                <img src={meadow} alt="meadow" style={{ width: '100%', position: 'absolute', bottom: 0, left: 0 }} />
                <div className="question-container" style={{ fontFamily: 'Bangers'}}>
                    <h1>Add The Sheep</h1>
                    <img src={sheep3} style={{ width: '20%' }} />
                    <p>Click on sheep, flowers, and answer questions as fast as you can!</p>
                    <div style={{ backgroundColor: 'white', padding: 10, color: 'black', borderRadius: 5, border: '1px solid lighgrey' }} onClick={() => this.reset()}>Start</div>
                </div>
            </div>
          </div>
      }

      if(this.state.showQuestion) {
          const { add1, add2 } = this.state.currentQuestion;
          return (
            <div className="App">
            <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: '#7CCCE8' }}>
                <img src={meadow} alt="meadow" style={{ width: '100%', position: 'absolute', bottom: 0, left: 0 }} />
                <div className="question-background"></div>
                <div className="question-container">
                    <div className="question">
                        <div className="addition">
                            <div className="add1">{add1}</div>
                            <div className="plus">+</div>
                            <div className="add2">{add2}</div>
                            <div className="equals">=</div>
                        </div>
                        <div className="answers">
                            { answers.map(a => <div className="answer" key={a} onClick={() => this.answerQuestion(a + 1)}>{a + 1}</div>)}
                        </div>
                    </div>
                </div>
                </div>

            </div>
          )
      }

    const questions = Object.keys(this.state.questions)
                            .map((key) => ({ id: key, ...this.state.questions[key] }))
                            .filter(q => q.answered === false);
    if(questions.length === 0) {
      return (
          <div className="App">
            <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: '#7CCCE8' }}>
                <img src={meadow} alt="meadow" style={{ width: '100%', position: 'absolute', bottom: 0, left: 0 }} />
                <div>All answered. Points: {this.state.points} + Time Bonus {(this.state.timeRemaining / 3).toFixed(0)} = { this.state.points + (this.state.timeRemaining / 3).toFixed(0) } </div>
            </div>
          </div>
      )
    }
    return (
      <div className="App">
        <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: '#7CCCE8' }}>
            <img src={meadow} alt="meadow" style={{ width: '100%', position: 'absolute', bottom: 0, left: 0 }} />
            <div style={{ color: 'black', position: 'fixed', zIndex: 1, top: 10, left: 10 }}>Points: {this.state.points}</div>
            <div style={{ color: 'black', position: 'fixed', zIndex: 1, top: 10, right: 10 }}>{finalTime}</div>
            {
                questions
                    .map((q, index) => {
                        return (
                            <img
                                key={`question-${index}`}
                                src={q.image}
                                alt={""}
                                onClick={() => this.revealQuestion(q.id)}
                                style={{ position: 'absolute', left: `${q.x}%`, bottom: `${q.y}%`, width: q.width || '10%' }}
                            />
                        )
                })
            }
        </div>
      </div>
    );
  }
}

export default App;



/** WEBPACK FOOTER **
 ** ./src/App.js
 **/